// Ce qu'un client a souscrit — vu et modifié par l'éditeur.
//
// C'EST ICI, ET NULLE PART AILLEURS, que les modules s'activent. Le client ne
// peut pas s'ouvrir un module qu'il n'a pas payé : les routes de cet espace
// répondent 404 à un administrateur client, pas même 403 — l'existence de la
// plateforme n'a pas à lui être confirmée.
//
// Le module Parc n'a pas d'interrupteur : tout s'y accroche, et les échéances
// réglementaires en font partie. Un client qui prend le Parc sans les
// inspections doit garder ses rappels de contrôle technique.
import { useState } from "react";

import api from "../api";

// L'ordre suit ce qu'on vend : les modules d'abord, puis ce qui se règle
// au cas par cas. Chaque ligne dit ce que le client GAGNE, pas le nom
// technique de la colonne.
const OPTIONS = [
  {
    champ: "module_vgp",
    titre: "Inspections et rapports",
    detail: "VGP hayon, contrôle technique, rapports PDF conformes.",
  },
  {
    champ: "module_operations",
    titre: "Coûts et carburant",
    detail: "Opérations d’entretien, pleins, coût au kilomètre.",
  },
  {
    champ: "module_stock",
    titre: "Gestion des stocks",
    detail:
      "Magasin de l’atelier, décrément automatique quand une intervention " +
      "consomme des pièces.",
  },
  {
    champ: "module_financement",
    titre: "Financement",
    detail:
      "Crédit-bail, LOA, crédit, valeur résiduelle. Encours de la flotte, " +
      "export Excel et PDF, alerte 90 jours avant la fin d'un contrat.",
  },
  {
    champ: "module_location",
    titre: "Location",
    detail:
      "Louer un camion à un tiers : contrat signé, photos de départ et de " +
      "retour, loyers, fins de location.",
  },
  {
    champ: "lecture_factures_active",
    titre: "Lecture automatique des factures",
    detail:
      "Payant à l’usage, et chaque image sort chez un sous-traitant. " +
      "À n’activer que si le client l’a demandé.",
    prudence: true,
  },
  {
    champ: "gestion_comptes_client",
    titre: "Le client ouvre ses propres comptes",
    detail:
      "Coupé, c’est vous qui ajoutez les comptes. Le client garde la gestion " +
      "des comptes existants : mot de passe, rôle, désactivation.",
    prudence: true,
  },
];

function messageErreur(err, defaut) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return defaut;
}

export default function ModulesClient({ client, onFermer, onChange }) {
  const [etat, setEtat] = useState(client);
  const [erreur, setErreur] = useState("");
  const [enCours, setEnCours] = useState("");

  const basculer = (champ) => {
    const valeur = !etat[champ];
    setEnCours(champ);
    setErreur("");
    api
      .patch(`/plateforme/clients/${client.id}`, { [champ]: valeur })
      // On repart de la réponse du SERVEUR, pas de la valeur qu'on vient
      // d'envoyer : si elle est refusée ou corrigée, l'écran doit montrer
      // l'état réel, pas celui qu'on espérait.
      .then(({ data }) => {
        setEtat(data);
        onChange?.(data);
      })
      .catch((err) => setErreur(messageErreur(err, "Modification impossible.")))
      .finally(() => setEnCours(""));
  };

  return (
    <div className="modal-overlay" onClick={onFermer}>
      <div className="modal-carte" onClick={(e) => e.stopPropagation()}>
        <h3 className="modal-titre">Modules souscrits</h3>
        <p className="modal-sous-titre">{client.nom}</p>

        {erreur && <p className="erreur">{erreur}</p>}

        {OPTIONS.map((o) => (
          <label key={o.champ} className="champ-interrupteur">
            <input
              type="checkbox"
              checked={!!etat[o.champ]}
              disabled={enCours === o.champ}
              onChange={() => basculer(o.champ)}
            />
            <span>
              <strong>{o.titre}</strong>
              <br />
              <span className={o.prudence ? "sous-info" : "note-discrete"}>
                {o.detail}
              </span>
            </span>
          </label>
        ))}

        <p className="sous-info">
          Le <strong>Parc</strong> n’a pas d’interrupteur : véhicules, papiers,
          références et échéances réglementaires sont toujours actifs. Un client
          sans inspections doit garder ses rappels de contrôle technique.
        </p>

        <div className="modal-actions">
          <button className="btn" onClick={onFermer}>
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
}
